import AbstractAPI from '@/services/api/AbstractAPI';

export default class ContactApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options);
  }

  async submit(firstName, lastName, email, phoneNumber, companyName, message, attachment = null) {
    const formData = new FormData();
    formData.append('firstname', firstName);
    formData.append('surname', lastName);
    formData.append('email', email);
    formData.append('telephone', phoneNumber);
    formData.append('company', companyName);
    formData.append('message', message);
    if (attachment !== null) {
      formData.append('attachment', attachment);
    }

    return this.makeRequest('/contact', 'post', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
  }

  async installerFeedback(message, currentPage) {
    return this.makeRequest(`/installer-feedback`, 'post', {message, currentPage});
  }
}
